<template>
  <div class="page-container">
    <div class="container-header">
      <div class="title">Title here</div>
      <div>Buttons here</div>
    </div>
    <projects-list></projects-list>
  </div>
</template>

<script>
import ProjectsList from "../components/ProjectsList.vue";
export default {
  components: {
    ProjectsList
  }
};
</script>
